// extracted by mini-css-extract-plugin
module.exports = {"creditCardIcon":"CreditCardIcon__creditCardIcon__26t-w"};